import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { TaxonomyGeneric } from '../../../types/uncinc_profile/taxonomy';

interface ParagraphTechnologiesOverviewProps
  extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<TaxonomyGeneric>;
}

const ParagraphTechnologiesOverview: React.FC<ParagraphTechnologiesOverviewProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="Paragraph ParagraphTechnologiesOverview">
      <Container>
        <h2 className="visually-hidden">{t('content_types.project.subheading')}</h2>
        <View
          id="technologies_overview"
          display="technologies_overview"
        />
      </Container>
    </div>
  );
};

export default ParagraphTechnologiesOverview;
